import { render, staticRenderFns } from "./ProceduresAdd.vue?vue&type=template&id=0abecbab"
import script from "./ProceduresAdd.vue?vue&type=script&lang=js"
export * from "./ProceduresAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports